var opts = {
    height: 'default'
};
export default opts;
/**
 * Extend shorthand options.
 *
 * @param  {object} options The options to extend.
 * @return {object}			The extended options.
 */
export function extendShorthandOptions(options) {
    if (typeof options == 'boolean' && options) {
        options = {
            height: 'auto'
        };
    }
    if (typeof options == 'string') {
        options = {
            height: options
        };
    }
    if (typeof options != 'object') {
        options = {};
    }
    return options;
}
;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/autoheight/_options.js
// module id = 10
// module chunks = 0